import React, { Component } from "react";
import { IndexLink, Link } from "react-router";
import Logo from "../../../components/Logo/NexoidDevLogo";

import Button from "@material-ui/core/Button";
import Tooltip from "@material-ui/core/Tooltip";

class NotFound extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <div>
        <Link to="/">
          <div style={{ backgroundColor: "#0f111a", padding: 10 }}>
            <div
              style={{
                marginLeft: "auto",
                marginRight: "auto",
                display: "block",
                width: 250,
                height: 77
              }}
            >
              <Logo />
            </div>
          </div>
        </Link>
        <div>
          <div
            style={{
              textAlign: "center",
              padding: 10,
              maxWidth: 920,
              display: "block",
              marginLeft: "auto",
              marginRight: "auto"
            }}
          >
            <div style={{ paddingTop: 60, paddingBottom: 20 }}>
              <h1 style={{ fontSize: 32, fontWeight: "normal" }}>
                <strong>404.</strong> Not found.
              </h1>
            </div>
            <div>
              <img src="img/notfound/NoFound.png" alt="Page not found" />
            </div>
            <div style={{ paddingTop: 20, paddingBottom: 40 }}>
              <h4 style={{ fontSize: 20, fontWeight: "normal" }}>
                We could not find this page on the server.
              </h4>
            </div>
            <div>
              <Button
                component={Link}
                to="/"
                variant="contained"
                style={{ color: "#ffffff", backgroundColor: "#3163ad" }}
              >
                Back To home
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default NotFound;



// WEBPACK FOOTER //
// ./src/routes/NotFound/components/NotFound.js